module.exports = "/_next/static/images/spanish-0511ed725c15b03a2da0d146b399b8b4.png";